import styled from 'styled-components';
import { SummaryDiscountDetailsStyled } from '../SummaryDiscountDetailsStyled';
import { rem } from 'polished';

export const SummaryDiscountDetailsOV = styled(SummaryDiscountDetailsStyled)`
    .titleWrapper {
        .title {
            text-transform: uppercase;
            font-size: ${rem(28)};
        }
    }
`;
